module.exports = __webpack_public_path__ + "static/media/ines_almeida.246e1147.jpg";